<div class="container-type" fxLayout="row wrap">
    <logzy-view-data-field label="Posted By" [name]="requestService.selectedRequest" [displayField]="'created_by'"
        [displayField1]="'first_name'" [displayField2]="'last_name'" [displayField3]="'company'"
        [displayField4]="'name'" fxFlex="12em" fxLayout="column" class="align-items-center"></logzy-view-data-field>
    <logzy-view-data-field label="Posted On" [date]="requestService.selectedRequest?.created_at" fxFlex="12em"
        fxLayout="column" class="align-items-center"></logzy-view-data-field>

    <logzy-view-data-field label="Last Updated By" [name]="requestService.selectedRequest" [displayField]="'updated_by'"
        [displayField1]="'first_name'" [displayField2]="'last_name'" fxFlex="12em" fxLayout="column"
        class="align-items-center"></logzy-view-data-field>
    <logzy-view-data-field label="Last Updated On" [date]="requestService.selectedRequest?.updated_at" fxFlex="12em"
        fxLayout="column" class="align-items-center"></logzy-view-data-field>
    <!-- <div fxFlex="20" class="example-full-width">
        <span>Quantity</span>
        <app-number-field [(ngModel)]="requirementObj.quantity" [(errors)]="requirementObj.error.quantity"
            [isEditable]="true" [minValue]="minValue">
        </app-number-field>
    </div> -->

    <!-- <div fxFlex="25" class="example-full-width">
        <span>Type</span>
        <app-mat-auto-search [(ngModel)]="requirementObj.container_size_type"
            [(errors)]="requirementObj.error.container_size_type" [isEditable]="true" [idField]="null"
            displayField='display' [trim]="true" [clearable]="false" [listUrl]="containerSizeTypeUrl"
            name="container_type">
        </app-mat-auto-search>
    </div>

    <div fxFlex="35" class="example-full-width">
        <span>Condition</span>
        <app-select-field [(ngModel)]="requirementObj.condition" [(errors)]="requirementObj.error.condition"
            [isEditable]="true" [idField]="null" [displayField]="'value'" [label]="'Condition'" [name]="'condition'"
            [options]="containerConditionList?.results" [searchable]="true" [trim]="true">
        </app-select-field>
    </div>

    <div fxFlex="100" class="updateReq">
        <button mat-raised-button (click)="updateRequirements()" class="Save">Save Requirements</button>
    </div> -->
</div>